import React from 'react';
import { Separator } from './ui/separator';

const footerLinks = {
  Product: [
    { label: 'How it works', href: '#how-it-works' },
    { label: 'Features', href: '#features' },
    { label: 'Coverage', href: '#coverage' },
    { label: 'Platforms', href: '#platforms' },
  ],
  Company: [
    { label: 'About us', href: '#innovation' },
    { label: 'Roadmap', href: '#roadmap' },
    { label: 'Contact', href: '#contact' },
    { label: 'Careers', href: '#contact' },
  ],
  Legal: [
    { label: 'Privacy policy', href: '#' },
    { label: 'Terms of service', href: '#' },
    { label: 'Cookie policy', href: '#' },
    { label: 'AML policy', href: '#' },
  ],
};

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-white border-t border-[#E7E7EF] py-12">
      <div className="container-main">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-icon.png" alt="TexSolution" className="h-7 w-auto" style={{ objectFit: 'contain' }} />
              <span className="text-lg font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif', color: '#0B0B10' }}>
                Tex<span style={{ color: '#7C3AED' }}>Solution</span>
              </span>
            </div>
            <p className="text-sm text-[#64647A] max-w-xs leading-relaxed mb-4">
              The next-generation digital wallet for global payments. One platform for QR payments, SWIFT/SEPA transfers, and cross-border payouts.
            </p>
            <p className="font-mono-accent text-xs text-[#A0A0B0] mb-1">
              Texsolution Payment Services Provider LLC
            </p>
            <p className="font-mono-accent text-xs text-[#A0A0B0] mb-1">
              License No. 1586044
            </p>
            <p className="font-mono-accent text-xs text-[#A0A0B0]">
              London · Singapore · Dubai
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-[#0B0B10] mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-[#64647A] hover:text-[#7C3AED] transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="bg-[#E7E7EF]" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
          <p className="font-mono-accent text-xs text-[#A0A0B0]">
            &copy; {new Date().getFullYear()} Texsolution Payment Services Provider LLC. All rights reserved. License No. 1586044
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-[#A0A0B0] hover:text-[#7C3AED] transition-colors" aria-label="Twitter">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a href="#" className="text-[#A0A0B0] hover:text-[#7C3AED] transition-colors" aria-label="LinkedIn">
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
